import { render, staticRenderFns } from "./helperStatistics.vue?vue&type=template&id=af7a7246&scoped=true&"
import script from "./helperStatistics.vue?vue&type=script&lang=js&"
export * from "./helperStatistics.vue?vue&type=script&lang=js&"
import style0 from "./helperStatistics.vue?vue&type=style&index=0&id=af7a7246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a7246",
  null
  
)

export default component.exports